// AR
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "تعديل جماعي",
    cfgTitle: "إعدادات التقويم",
    syncSection: "المزامنة",
    resyncOta: "إعادة المزامنة مع OTA",
    resyncOtaSub: "إعادة إرسال التوفّر والأسعار إلى القناة.",
  },
  mode: {
    calendar: "التقويم",
    rates: "الأسعار",
  },
  search: {
    placeholder: "ابحث عن نزيل أو رمز…",
    clear: "مسح",
    go: "بحث",
    resultsHint: "{count} نتيجة — اختر واحدة:",
    combo: "مجمّعة · {count} غرفة",
  },
  header: {
    occupancy: "الإشغال {pct}%",
  },
  type: {
    roomsAbbr: "غرفة",
    configTitle: "إعدادات النوع (OTA وقواعد الوصول/المغادرة)",
    otaConnected: "OTA متصلة",
    subscribeToConnect: "اشترك لربط قنوات OTA",
  },
  rtCell: {
    editTooltip: "انقر لتعديل التوفّر والسعر والحد الأدنى والإغلاق",
    overbookRisk: "خطر تجاوز الحجز",
    closedTag: "مغلق",
  },
  rules: {
    sameDayCutoff: "إيقاف بيع نفس اليوم عند {time}",
  },
  organizeRow: {
    title: "بانتظار التنظيم",
    unplacedCount: "{count} حجز غير مُوزَّع | {count} حجوزات غير مُوزَّعة",
    autoTooltip: "يعيد ترتيب الحجوزات تلقائيًا بين الغرف بحيث تتّسع جميعها",
    organizing: "جارٍ التنظيم…",
    organize: "تنظيم",
  },
  footer: {
    available: "متاح",
    unavailable: "غير متاح",
    closed: "مغلق",
    overbookRisk: "خطر تجاوز الحجز",
    realtime: "يتم تحديث القيم في الوقت الفعلي",
    timezone: "المنطقة الزمنية: {tz}",
  },
  dayEdit: {
    oneDay: "يوم واحد",
    open: "مفتوح",
    closed: "مغلق",
    priceLabel: "السعر · التعرفة القياسية",
    minStayLabel: "الحد الأدنى للإقامة (ليالٍ)",
    forSaleLabel: "الغرف المعروضة للبيع",
    forSaleHint: "الحد · الأقصى {max}",
    applyMultiple: "تطبيق على عدة تواريخ؟",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
  },
  roomMenu: {
    create: "إنشاء حجز",
    createSub: "حجز في النطاق المحدد",
    block: "حجب غرفة واحدة",
    blockSub: "إغلاق هذه الغرفة خلال النطاق",
    unblock: "إزالة الحجب",
    unblockSub: "إعادة فتح هذه الغرفة خلال النطاق",
    oos: "خارج الخدمة",
    oosSub: "صيانة هذه الغرفة",
  },
  closureMenu: {
    turnoverTitle: "يضعه وقت التحضير",
    turnoverSub: "ينتقل مع تواريخ الحجز ويختفي عند إلغائه.",
    changeRule: "تغيير القاعدة",
    changeRuleSub: "ضبط وقت التحضير أو تعطيله",
    editReason: "تعديل السبب",
    editReasonSub: "تغيير سبب الحجب",
    changeRoom: "تغيير الغرفة",
    changeRoomSub: "النقل إلى غرفة أخرى من النوع",
    unblock: "إزالة الحجب",
    unblockSub: "إعادة الفتح وتحرير المساحة",
    moveTo: "النقل إلى…",
    noOtherRooms: "لا توجد غرف أخرى في هذا النوع.",
    barTooltip: "حجب: {reason} — انقر للتعديل أو الإزالة",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "إدارة اتصال OTA",
    connectOta: "ربط OTA",
    otaSub: "مزامنة مكان الإقامة مع قنوات OTA",
    arrivalRules: "قواعد الوصول والمغادرة",
    arrivalRulesSub: "أيام تسجيل الدخول / المغادرة المسموح بها",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "مُباعة بالساعة",
    soldOne: "مُباعة بالساعة · {range}",
    soldMany: "مُباعة بالساعة · {count} إقامات",
  },
  tooltip: {
    past: "منقضية",
    unassignedHtml: "<strong>لا توجد غرفة مُخصَّصة.</strong> التوفّر موزّع بين الغرف. استخدم <strong>تنظيم</strong> لإعادة ترتيبه تلقائيًا، أو انقر وخصّص له غرفة.",
    nights: "{count} ليلة | {count} ليالٍ",
    guests: "{count} نزيل | {count} نزلاء",
  },
  channels: {
    direct: "مباشرة",
  },
  syncModal: {
    title: "المزامنة مع OTA",
    message: "ستُعاد مزامنة التوفّر والحد الأقصى للإقامة في هذا التقويم وإرسالها إلى OTA.",
    confirm: "نعم، زامِن",
    cancel: "إلغاء",
  },
  syncTooltip: {
    can: "يعيد حساب التوفّر والحد الأقصى للإقامة ويرسلهما إلى OTA (يمنع تجاوز الحجز).",
    cannot: "اربط مكان الإقامة بقناة لتتمكّن من المزامنة.",
  },
  block: {
    editTitle: "تعديل السبب",
    createTitle: "حجب غرفة",
    reasonLabel: "سبب الحجب",
    reasonHint: "(سيظهر في التقويم)",
    placeholder: "مثال: صيانة، استخدام المالك…",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveReason: "حفظ السبب",
    blockBtn: "حجب",
    defaultReason: "محجوب",
    thisRoom: "هذه الغرفة",
    editReasonMsg: `تعديل سبب حجب "{room}" ({count} ليلة). | تعديل سبب حجب "{room}" ({count} ليالٍ).`,
    createMsg: `سيتم إغلاق "{room}" ({unit}) لمدة {count} ليلة. لن يكون الحجز فيها ممكنًا في تلك التواريخ؛ تبقى بقية غرف النوع متاحة. | سيتم إغلاق "{room}" ({unit}) لمدة {count} ليالٍ. لن يكون الحجز فيها ممكنًا في تلك التواريخ؛ تبقى بقية غرف النوع متاحة.`,
    presets: {
      maintenance: "صيانة",
      ownerUse: "استخدام المالك",
      renovation: "تجديد",
      deepCleaning: "تنظيف عميق",
      externalReserved: "محجوز (خارجي)",
    },
  },
  organizeModal: {
    title: "التنظيم تلقائيًا",
    bodyHtml: `سنبحث عن أفضل توزيع و<strong>نعيد ترتيب الحجوزات بين الغرف</strong> من هذا النوع بحيث يتّسع <strong>{count} حجز غير مُوزَّع</strong> بشكل متتالٍ. | سنبحث عن أفضل توزيع و<strong>نعيد ترتيب الحجوزات بين الغرف</strong> من هذا النوع بحيث تتّسع <strong>{count} حجوزات غير مُوزَّعة</strong> بشكل متتالٍ.`,
    point1Html: "تتغيّر فقط <strong>الغرفة الفعلية</strong> المُخصَّصة.",
    point2Html: "لا يتم المساس بـ<strong>التواريخ أو الأسعار أو النزلاء</strong>.",
    point3: "إذا لم يتّسع أيٌّ منها بشكل متتالٍ، فسننبّهك.",
    cancel: "إلغاء",
    organizing: "جارٍ التنظيم…",
    confirm: "نعم، نظِّم",
  },
  empty: {
    noHotelTitle: "لا توجد إعلانات من نوع فندق",
    noHotelSubHtml: "أنشئ إعلانًا من نوع <strong>فندق</strong> أو <strong>تخييم</strong> لبدء إدارة التوفّر حسب الغرف.",
    noHotelBtn: "الانتقال إلى الإعلانات",
    noRoomsTitle: "{name} لا يحتوي على غرف",
    noRoomsSub: "لا يحتوي هذا الإعلان على أي غرف مُسجّلة بعد. أضف غرفًا من إعدادات الإعلان لعرض التقويم.",
    noRoomsBtn: "تهيئة الإعلان",
  },
  mock: {
    today: "اليوم",
    month: "مايو ٢٠٢٦",
    searchPlaceholder: "ابحث بالاسم أو الرمز…",
    searchBtn: "بحث",
    createBtn: "إنشاء حجز",
    na: "غ/م",
    forSaleLabel: "المتاح للبيع",
    suiteDeluxe: "جناح ديلوكس",
    standardRoom: "غرفة قياسية",
    roomsCount2: "(غرفتان)",
    roomsCount3: "(٣ غرف)",
    no: "رقم",
    room101: "غرفة ١٠١",
    room102: "غرفة ١٠٢",
    room201: "غرفة ٢٠١",
    room202: "غرفة ٢٠٢",
    room203: "غرفة ٢٠٣",
    d1: "إثن ١",
    d2: "ثلا ٢",
    d3: "أرب ٣",
    d4: "خمي ٤",
    d5: "جمع ٥",
    d6: "سبت ٦",
    d7: "أحد ٧",
    d8: "إثن ٨",
    d9: "ثلا ٩",
    d10: "أرب ١٠",
    d11: "خمي ١١",
    d12: "جمع ١٢",
  },
  ops: {
    closingDay: "جارٍ إغلاق اليوم…",
    openingDay: "جارٍ فتح اليوم…",
    saving: "جارٍ الحفظ…",
    movingBlock: "جارٍ نقل الحجب…",
    swappingBlockReservation: "جارٍ تبديل الحجب والحجز…",
    swappingReservationBlock: "جارٍ تبديل الحجز والحجب…",
    swappingRooms: "جارٍ تبديل الغرف…",
    changingRoom: "جارٍ تغيير الغرفة…",
    organizingRooms: "جارٍ تنظيم الغرف…",
    syncingWithOta: "جارٍ مزامنة التقويم مع OTA…",
    processing: "جارٍ المعالجة…",
    settingMaintenance: "جارٍ التحويل إلى الصيانة…",
    clearingMaintenance: "جارٍ إزالة الصيانة…",
    updatingAvailability: "جارٍ تحديث التوفّر…",
    updatingReason: "جارٍ تحديث السبب…",
    closingRoom: "جارٍ إغلاق الغرفة…",
    removingBlock: "جارٍ إزالة الحجب…",
  },
  toasts: {
    dayClosed: "تم إغلاق اليوم",
    dayOpened: "تم فتح اليوم",
    availabilityUpdateErr: "تعذّر تحديث التوفّر",
    dayUpdated: "تم تحديث اليوم",
    daySaveErr: "تعذّر حفظ اليوم",
    moveTargetMultipleReservations: "الوجهة تحتوي على عدة حجوزات في هذا النطاق؛ انقلها يدويًا.",
    roomRejectsBlock: "هذه الغرفة لا تقبل الحجب في هذا النطاق",
    blockMoved: "تم نقل الحجب إلى غرفة أخرى",
    blockMoveErr: "تعذّر نقل الحجب",
    swapStartErr: "تعذّر بدء التبديل",
    reservationNoFitSwap: "الحجز لا يتّسع في الغرفة الأخرى طوال نطاقه؛ تعذّر التبديل.",
    reservationMoveErr: "تعذّر نقل الحجز",
    swapCompleteErr: "تعذّر إتمام التبديل (تمّت الاستعادة)",
    blockReservationSwapped: "تم تبديل الحجب والحجز",
    swapErr: "تعذّر التبديل",
    rangeHasOccupiedOrClosed: "يتضمّن النطاق ليالي مشغولة أو مغلقة في هذه الغرفة.",
    organizeErr: "تعذّر التنظيم تلقائيًا.",
    organizeNothing: "لم يكن هناك ما يُعاد تنظيمه.",
    organizePartial: "تم تنظيم {done} حجز، لكن {unplaced} لا يتّسع بشكل متتالٍ في أي توزيع.",
    organizeDoneAssigned: "تم تنظيم التقويم: {assigned} مُخصَّص",
    organizeDoneMoved: "، {moved} مُنقَل إلى غرفة أخرى",
    swapGroupDone: "اكتمل التبديل الجماعي: {groupCount} ⇄ {swappedCount} حجز.",
    roomsSwappedWith: "تم تبديل الغرف مع {names}.",
    noPropertyToSync: "لا يوجد مكان إقامة للمزامنة.",
    calendarResynced: "تمت إعادة حساب التقويم ومزامنته مع OTA.",
    syncErr: "تعذّرت مزامنة التقويم مع OTA.",
    genericError: "خطأ",
    reservationNoFitSwapStrict: "تعذّر التبديل: الحجز غير متاح طوال نطاقه.",
    reservationBlockSwapped: "تم تبديل الحجز والحجب",
    roomCloseErr: "تعذّر إغلاق الغرفة",
    reasonUpdated: "تم تحديث السبب",
    roomClosedInRange: "تم إغلاق الغرفة خلال النطاق",
    blockRemoved: "تمت إزالة الحجب",
    blockRemoveErr: "تعذّرت إزالة الحجب",
    searchMinChars: "اكتب حرفين على الأقل للبحث",
    searchNoResults: "لم يتم العثور على حجوزات لهذا البحث",
    searchErr: "خطأ في البحث عن الحجوزات",
  },
  summary: {
    stateAvailable: "متاح",
    stateClosed: "مغلق",
    stateNoDisp: "غ/م",
  },
};
